import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import BoilerQuote from "@/components/sections/BoilerQuote";
import Portfolio from "@/components/sections/Portfolio";
import About from "@/components/sections/About";
import Testimonials from "@/components/sections/Testimonials";
import TrustStrip from "@/components/sections/TrustStrip";
import QuoteSection from "@/components/sections/QuoteSection";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#F9F8F6] text-[#1A1A1A]">
      <Header />
      <Hero />
      <TrustStrip />
      <Services />
      <BoilerQuote />
      <Portfolio />
      <About />
      <Testimonials />
      <QuoteSection />
      <Contact />
      <Footer />
    </main>
  );
}
